// extracted by mini-css-extract-plugin
export default {"dark-modal":"SentEmailPopup_dark-modal__utxsN"};